import { useContext } from 'react'
import classnames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'
import { Panel } from '../..'
import { GemGrid } from '../Gem'
import PropTypes from 'prop-types'
import { Waypoint } from 'react-waypoint'
import { ScrolledIntoView, EVENTS_LABELS } from '../../../constants/trackingEvents'
import { oneTimeTagEventDispatcher } from '../../../helpers/tagManager'
import { OVERLAY_HELPERS } from '../../../constants/navigation'
import { PURCHASING_POWER_TOPIC_KEY } from '../../../constants/topicKeys'
import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useAmplitudeDebounceSetters } from '../../../hooks/tracking'

import styles from './PurchasingPower.module.scss'

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.PurchasingPowerModule,
})

const propTypes = {
  className: PropTypes.string,
  gems: PropTypes.array,
  showDetail: PropTypes.bool,
  selectedDetail: PropTypes.func,
  selectedGem: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  question: PropTypes.object,
  topic: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  topicKey: PropTypes.string,
}

const PurchasingPower = ({
  className,
  gems,
  showDetail,
  selectedDetail,
  selectedGem,
  show,
  hide,
  question,
  topic,
  topicKey,
}) => {
  const intl = useIntl()

  const { ampli } = useContext(AmplitudeContext)

  const [trackModuleViewed] = useAmplitudeDebounceSetters(() =>
    ampli?.moduleViewed({ module_name: AmplitudeEventConstants.PURCHASE_POWER })
  )

  const handleTrackEvent = () => {
    scrollIntoView()
    trackModuleViewed()
  }

  return (
    <Panel
      data-qa='PurchasingPowerCard'
      className={classnames(className, styles.card)}
    >
      <Panel.Heading className={styles.heading} id='purchasingPower'>
        <FormattedMessage
          id='Homeowner.purchasePower.heading'
          defaultMessage='If you bought another home, how much could you afford?'
        />
      </Panel.Heading>
      <Waypoint onEnter={handleTrackEvent} bottomOffset='50%'>
        <div />
      </Waypoint>
      <GemGrid
        className={styles.grid}
        horizontal
        data={gems}
        selectedDetail={selectedDetail}
        selectedGem={selectedGem}
        show={show}
        hide={hide}
        collapsed={showDetail}
        question={question}
        topic={topic}
        topicKey={topicKey || PURCHASING_POWER_TOPIC_KEY}
        disableCospo
        overlayPanelName={OVERLAY_HELPERS.purchasing.overlay}
        overlayPanelFrom={OVERLAY_HELPERS.purchasing.getOrigin()}
        overlayPanelTitle={OVERLAY_HELPERS.getTitle(
          'purchasing',
          intl.formatMessage
        )}
      />
    </Panel>
  )
}
PurchasingPower.propTypes = propTypes

export default PurchasingPower
